// extracted by mini-css-extract-plugin
module.exports = {"root":"select-trigger_root__IY2R4","error":"select-trigger_error__UdWjE","disabled":"select-trigger_disabled___5o1_","icon":"select-trigger_icon__P0mU_"};